module.exports = __webpack_public_path__ + "school/img/biaozuo.f693b7a4.jpg";